import PosthogService from '~/services/posthog/PosthogService';
import { toCandidatePositionProperties, type IConfirmCandidatePositionContext } from './types';

/**
 * Fires when an office clicks "Leave Anyway" on the "Candidate Not Confirmed"
 * exit popup, abandoning the Confirm Candidate screen while top candidates are
 * still available. Does not fire on "Go Back" or on dismissing the popup.
 *
 * Event: dental_portal:confirm_candidate:leave_clicked
 */
export function fireConfirmCandidateLeaveClicked(
  payload: IConfirmCandidatePositionContext,
): void {
  PosthogService.getInstance().track(
    'dental_portal:confirm_candidate:leave_clicked',
    toCandidatePositionProperties(payload),
  );
}
